import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import MissionsList from "../../MissionsList";
import ItemMission from "../../MissionsList/ItemMission";
import iconDailyLogin from "../../../../../../assets/images/Mini-Game/icon-daily-login.svg";
import iconPlace3Turns from "../../../../../../assets/images/Mini-Game/icon-place-3-turns.svg";
import PATH from "../../../../../../config/PATH";
import { useNavigate } from "react-router";
import iconBuyBid from "../../../../../../assets/images/Mini-Game/icon-buy-bid.svg";
import iconChangeCoins from "../../../../../../assets/images/Mini-Game/icon-change-coins.png";
import { curStateAccount } from "../../../../../../Redux/selector";
import { useSelector } from "react-redux";
import _ from "lodash";
import { ID_TAB_MINI_GAME } from "../../../../../../helper/const";
import { useTranslation } from "react-i18next";

export default function MissionEarnCoins({
  handleShowPopupLogin,
  missionMiniClick = () => {},
  setStep,
  buttonAction,
  turn,
  handleValueInput,
  isSmall = false,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [bidTotal, setBidTotal] = useState(0);
  const selectorAccount = useSelector(curStateAccount);

  useEffect(() => {
    if (selectorAccount.remainTurn) {
      const bidTotal = selectorAccount.remainTurn?.reduce((acc, pack) => {
        return acc + pack?.turn;
      }, 0);
      setBidTotal(bidTotal);
    }
  }, [selectorAccount.remainTurn]);
  const dailyMissions = [
    {
      id: 1,
      icon: iconDailyLogin,
      name: t("mini_game.pop_up_earn_more.mission_to_earn"),
      status: "execute",
      titleFooter: t("mini_game.pop_up_earn_more.complete_to_earn"),
      link: `${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`,
      isEarnMore: true
    },

    {
      id: 2,
      icon: iconBuyBid,
      name: "Buy more coins",
      status: "execute",
      titleFooter: "Buy with Sub or Retail packages",
      link: "/account/package",
      contentButton: "Buy",
      isEarnMore: true
    },
  ];

  const handleChangeTurn = () => {
    if (_.isEmpty(selectorAccount.userInfo)) {
      return handleShowPopupLogin();
    }
    setStep("change Coins");
    missionMiniClick();
  };

  return (
    <Container isSmall={isSmall}>
      <ItemMission data={dailyMissions[0]} isDaily />
      <ItemMission
        isShowWarning={
          _.isEmpty(selectorAccount.userInfo) ? false : turn > bidTotal
        }
        isChangeCoins
        contentWarning={
          bidTotal !== 0
            ? t("mini_game.standard_missions.number_exceeds")
            : t("mini_game.standard_missions.no_turns_left")
        }
      >
        <div className='change-turn'>
          <div className='btn-container'>
            <button onClick={() => buttonAction("minus")}>-</button>
            <input className='btn-total' value={turn} />
            <button onClick={() => buttonAction("add")}>+</button>
          </div>
          <button
            className={`btn-change-turn ${
              bidTotal === 0 || turn > bidTotal ? "disable-btn" : ""
            }`}
            onClick={handleChangeTurn}
          >
            {
              `${t("mini_game.standard_missions.change_turns").replace("X", turn).replace("turns", +turn > 1 ? "turns" : "turn")}`
            }
          </button>
        </div>
      </ItemMission>
      {/* <ItemMission data={dailyMissions[1]} isDaily /> */}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .disable-btn {
    pointer-events: none;
    background-color: #d0d5dd !important;
    border: 1px solid #d0d5dd;
    color: #98a2b3;
  }

  .warning-change-turn {
    position: relative;
    width: 100%;
    background-color: #fef3f2;
    padding: 10px;
    text-align: center;
    border-radius: 8px;
    color: #d92d20;
    font-style: italic;
    margin-top: 16px;
    text-wrap: stable;
    
    div {
      color: #2970ff;
      font-weight: 500;
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .change-turn {
    margin-top: 14px;
  }

  .container-change-coins-mini {
    display: flex;
    justify-content: space-between;
    position: relative;

    .btn-change-turn {
      font-size: 16px;
      position: absolute;
      bottom: 0;
      width: 172px;
      right: 0;

      &:hover {
        scale: 1.05;
        transition: all 0.3s ease-in-out;
      }

      @media (max-width: 625px) {
        font-size: 14px;
      }

      @media (max-width: 576px) {
        padding: 12px;
      }

      @media (max-width: 475px) {
        font-size: 12px;
        width: 135px;
      }

      @media (max-width: 468px) {
        width: fit-content;
      }

      @media (max-width: 425px) {
        padding: 12px;
      }
    }
  }

  .btn-container {
    @media (max-width: 412px) {
      gap: 4px;
    }
  }

  .btn-container button {
    /* padding: 0; */
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn-container input {
    height: 40px;
    font-size: 20px;

    @media (max-width: 500px) {
      font-size: 16px;
      /* width: 40px; */
    }

    @media (max-width: 425px) {
      width: 45px;
      font-size: 14px;
    }

    @media (max-width: 375px) {
      width: 40px;
      font-size: 11px;
    }
  }

  .excute-daily {
    background-color: #f97a1c;
    color: white;
    font-size: 16px;

    @media (max-width: 625px) {
      font-size: 14px;
    }

    @media (max-width: 475px) {
      font-size: 12px;
      width: 70px;
    }
  }

  ${(props) =>
    props.isSmall
      ? `
        .excute-daily {
          font-size: 14px;

          @media (max-width: 768px) {
            font-size: 12px;
            width: 70px;
          }
        }
        .btn-change-turn {
          font-size: 14px!important;

          @media (max-width: 768px) {
            font-size: 12px!important;
          }

          @media (max-width: 392px) {
            height: 40x;
          }
        }   `
      : ``
    }

    @media (max-width: 400px){
      .btn-change-turn{
        max-width: 125px;
        line-height: 17px;
      }
    }
`;
